import { useEffect, useState } from "react";
import { navLinks, whatsappUrl } from "@/mocks/serra";
import Logo from "@/components/Logo";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 border-b ${
        scrolled
          ? "bg-bg/85 backdrop-blur-xl border-white/10 py-3"
          : "bg-transparent border-transparent py-6"
      }`}
    >
      <div className="w-full px-6 lg:px-10">
        <div className="flex items-center justify-between">
          <a href="#top" className="flex items-center gap-3 cursor-pointer">
            <Logo className="w-9 h-9" />
            <span className="font-semibold text-white whitespace-nowrap">
              Serra Consultoria
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-9">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm text-white/70 hover:text-white transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
            <a
              href={whatsappUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm font-medium rounded-full bg-orange hover:bg-coral text-bg px-5 py-2.5 transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              Solicitar Diagnóstico
            </a>
          </div>

          <button
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg text-white cursor-pointer"
            aria-label="Abrir menu"
          >
            <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>

        {open && (
          <div className="lg:hidden mt-4 rounded-2xl bg-blue/30 border border-white/10 p-4 flex flex-col gap-1 animate-fade-in">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="text-sm text-white/70 hover:text-white hover:bg-white/5 rounded-lg px-4 py-3 transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href={whatsappUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="mt-1 inline-flex items-center justify-center gap-2 text-sm font-medium rounded-full bg-orange text-bg px-5 py-3 cursor-pointer whitespace-nowrap"
            >
              Solicitar Diagnóstico
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}
